import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const ValidateDictionaryRowButton = ({ onClick, disabled }) => {
  const intl = useIntl();
  return (
    <Button
      className="aridhia-row-validate-button"
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      compact
      basic
      icon
      data-tooltip={intl.formatMessage({ id: 'actions.validate.dictionary.row' })}
      data-position="bottom right"
    >
      <Icon name="play" className="primary" alt={intl.formatMessage({ id: 'actions.validate.dictionary.row' })} />
    </Button>
  );
};

export default ValidateDictionaryRowButton;
